import "../css/topPicks.css";
import loadPreview from "./../../../../server/utils/loadPreview";
import getDomain from "./../../../../server/utils/getDomain";
import { isNewRequestRequired, getDataFromStorage } from "./sessionStorage";
import getNewRequestData from "./getNewRequestData";
import implementSlider from "./implementSlider";
import initialiseEvents from "./initialiseEvents";
import hasStorage from "../../../../server/utils/hasStorage";

const setBrand = () => {
	if (window.location.href.indexOf('littlewoods.') !== -1) {
		window.bf20.brand = 'lw';
	}
	else if (window.location.href.indexOf('littlewoodsireland.') !== -1) {
		window.bf20.brand = 'lwi';
	} 
	else if (window.location.href.indexOf('very.ie') !== -1) {
		window.bf20.brand = 'lwi';
	} 
	else {
		window.bf20.brand = 'very';
	}
}

const setDevice = () => {
	window.bf20.deviceType = document.getElementById('deviceType').value;  
}


const setCurrencySymbol = () => {	
	if (window.bf20.brand === 'lwi') {
		window.bf20.currencySymbol = '&#8364;'
    } else {
		window.bf20.currencySymbol = '&#163;'
	}
}

const executeTopPicks = () => {
	shopdirect.event.subscribe('bf-home/top-picks', function(data) {
		implementSlider(data.productData);
	});	

	setBrand();
	setDevice();
	setCurrencySymbol();
	hasStorage();

	/*
		Check if we can use data stored in session data otherwise call galleryInfo.jsp
	*/
	isNewRequestRequired() ? 
		getNewRequestData()
		: getDataFromStorage()	
};

/*
	Execution
*/
if (window.location.href.indexOf("bf20TopPicks") !== -1) {
	const domain = getDomain();
	const path = "/assets/static/no-cache-assets/blackFriday20/home/topPicksData-preview.js";	
	loadPreview(`${domain}${path}`, () => {
		window.bf20.previewMode = true;
		executeTopPicks();
	});
} else {
	window.bf20.previewMode = false;
	executeTopPicks();		
}

initialiseEvents();